import styled from 'styled-components';
import { Image as ImageBase } from '@hamrolt/components';
import { useDocument } from '../hooks/useDocument';
import { FileData, fileDefaultData } from '../hooks/useFile';
import { DocumentReference } from '../firebase';

type Order = string[];

interface CommonData {
	order: Order;
	image: FileData;
}

interface LocalizedData {
	heading: string;
	bodyHTML: string;
}

const defaultLocalizedData: LocalizedData = {
	heading: '',
	bodyHTML: ''
};

interface Props {
	res: {
		base: DocumentReference;
		localized: DocumentReference;
	};
	className?: string;
}

const Title = styled.h2`
	box-sizing: border-box;
	display: block;
	width: 100%;
	margin: 0;
	padding: 0;
	${({ theme }) => theme.typography.heading6};
	color: inherit;
	font-weight: bold;
`;

const Container = styled.section`
	display: grid;
	grid-template-rows: 190px auto auto;
	align-items: end;
	min-height: 360px;
	padding: 16px;
	box-shadow: 0 0 80px rgba(0, 0, 0, .08);
`;

const Body = styled.div`
	${({ theme }) => theme.typography.richtext};
`;

const Image = styled(ImageBase)`
	display: block;
	width: 100%;
`;

const defaultCommonData: CommonData = {
	order: [],
	image: fileDefaultData
};

export const Flyer = ({ res, className }: Props) => {
	const { data: common } = useDocument<CommonData>(res.base, defaultCommonData);
	const { data: localized } = useDocument<LocalizedData>(res.localized, defaultLocalizedData);

	return <Container className={className} data-testid="flyer">
		<Image src={common.image.url} />
		<Title>{localized.heading}</Title>
		<Body dangerouslySetInnerHTML={{ __html: localized.bodyHTML }} />
	</Container>
}